import { useTranslation } from "react-i18next";
import {
  Button,
  Checkbox,
  Col,
  Form,
  message,
  Modal,
  Radio,
  Row,
  Space,
  TableColumnsType,
  TableProps,
  Typography
} from 'antd'
import React, {useEffect, useState} from 'react'
import FormInput from '../../form-input/FormInput'
import {ExclamationCircleOutlined, SearchOutlined} from '@ant-design/icons'
import TableData from '../../table-data/TableData'
import FormItemDropdown from '../../form-dropdown/FormItemDropdown'
import {isEmpty} from 'lodash'
import {useParams} from 'react-router-dom'
import {
  createTemplateSequence,
  getAllSectionByCourseId,
  getListSequenceTemplate
} from '../../../service/content-list-course/contentListCourseApi'

type Props = {
  open: boolean
  handleClose: () => void
  filterData: any;
  tab: string
  getListDataProps: () => void
}

export default function AddTemplateSequenceCourse(props: Props) {
  const { t } = useTranslation();
  const {open, handleClose, filterData, tab, getListDataProps} = props

  const [listData, setListData] = useState<any>([])
  const [sectionList, setSectionList] = useState<any>([])
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [statusOrder, setStatusOrder] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [clearRowKey, setClearRowKey] = useState<boolean>(true)
  const [searchValueSynPopup, setSearchValueSynPopup] = useState<string>('')
  const CheckboxGroup = Checkbox.Group;
  const [form] = Form.useForm()
  const params = useParams()

  const validations = {
    sectionName: {
      required: true,
      message: t("Vui lòng chọn chương", "Vui lòng chọn chương"),
    },
    sequenceName: {
      required: true,
      message: t("Vui lòng nhập tên bài giảng", "Vui lòng nhập tên bài giảng"),
    },
  };

  const renderStatus = (value: string) => {
    switch (Number(value)) {
      case 0:
        return "Bản nháp"
        break;
      case 1:
        return "Sắp ra mắt"
        break;
      case 2:
        return "Miễn phí"
        break;
      case 3:
        return "Trả phí"
        break;
      default:
        return "Bản nháp"
        break;
    }
  }

  const dataColumnsLesson: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên khoá học", "Tên khoá học"),
      dataIndex: "courseName",
      key: "courseName",
      sorter: true,
      width: 30,
    },
    {
      title: t("Tên chương", "Tên chương"),
      dataIndex: "sectionName",
      key: "sectionName",
      sorter: true,
      width: 30,
    },
    {
      title: t("Tên bải giảng mẫu", "Tên bải giảng mẫu"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 30,
    },
    {
      title: t("Mô tả", "Mô tả"),
      dataIndex: "description",
      key: "description",
      width: 30,
    },
  ]

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
  };

  const getDataSectionByid = async () => {
    const data = {
      keyword: searchValueSynPopup.trim() ?? null,
      page: pageNumber,
      pageSize: pageSize
    }
    await getListSequenceTemplate(data).then((res: any) => {
      setListData(res.data?.content)
      setTotalRecords(res.data?.totalElements)
      getListDataProps()
    })

  }

  const getListData = async () => {
    getDataSectionByid()
  };

  const getAllSection = async () => {
    await getAllSectionByCourseId(params?.id).then((res) => {
      setSectionList(res.data)
    })
  }

  const addNewTemplate = async (values: any) => {
    const arrIdSelectedRowkey = selectedRowKeys.map((item: any) => item.id)

    const data = {
      key: arrIdSelectedRowkey[0],
      sectionId: values.sectionName,
      name: values.sequenceName,
      description: values.description,
      status: 0
    }

    await createTemplateSequence(data).then((res) => {
      if (res.status === 200) {
        message.success(t("Tạo bài giảng từ mẫu thành công", "Tạo bài giảng từ mẫu thành công"))
        form.resetFields()
        handleClose()
        setClearRowKey(true)
        getListDataProps()
        setLoading(false)
      }
    })
  }


  useEffect(() => {
    getListData();
    getAllSection()
    if (!open) {
      setSearchValueSynPopup("")
      setSelectedRowKeys([])
      form.resetFields()
      setClearRowKey(true)
    }
  }, [open, pageNumber, statusOrder]);

  return (
    <Form.Provider onFormFinish={async (name, {values, forms}) => {
      if (name === "add-template-sequence-modal") {
        if (isEmpty(selectedRowKeys)) {
          message.error(t("Bạn chưa chọn bài giảng mẫu để tạo mẫu", "Bạn chưa chọn bài giảng mẫu để tạo mẫu"))
          return
        }

        Modal.confirm({
          title: `Xác nhận thêm bài giảng từ mẫu bài giảng`,
          content: `Bạn có chắc chắn muốn thêm bài giảng từ mẫu bài giảng?`,
          onOk: () => {
            addNewTemplate(values);
          },
          okText: t("Xác nhận", "Xác nhận"),
          cancelText: t("Huỷ", "Huỷ"),
          centered: true,
          icon: <ExclamationCircleOutlined style={{color: "#1677FF"}}/>,
          footer: (_, {OkBtn, CancelBtn}) => (
            <>
              <CancelBtn/>
              <OkBtn/>
            </>
          ),
        });

      }
    }}>
      <Modal
        className="add-template-sequence-course-modal"
        title={t("Thêm bài giảng từ bài giảng mẫu", "Thêm bài giảng từ bài giảng mẫu")}
        closeIcon={true}
        centered
        open={open}
        onCancel={handleClose}
        footer={null}
        width={"80%"}
      >
        <Form
          form={form}
          name="add-template-sequence-modal"
          layout="vertical"
        >
          <Row gutter={40} className='p-6'>
            <Col md={{span: 16}} lg={{span: 16}} xl={{span: 16}} xs={{span: 16}}>
              <Form.Item name="search">
                <FormInput
                  placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
                  value={searchValueSynPopup}
                  onChange={(e: any) => setSearchValueSynPopup(e.target?.value)}
                  onKeyPress={(e: any) => setSearchValueSynPopup(e.target?.value)}
                  afterPrefixIcon={<SearchOutlined className='cursor-pointer' onClick={getDataSectionByid}/>}
                />
              </Form.Item>

              <TableData
                dataTable={listData}
                dataColumns={dataColumnsLesson}
                setPageNumber={setPageNumber}
                selectOneRow={true}
                clearRowkey={open}
                setPageSize={setPageSize}
                pageNumber={pageNumber}
                pageSize={pageSize}
                loadingTable={loading}
                scroll={{x: 1500, y: 600}}
                totalRecords={totalRecords}
                handleTableChangeProps={handleTableChange}
                setSelectedRowKeysProps={setSelectedRowKeys}
                rowSelected={selectedRowKeys}
                pagination={true}
                hideSelection={true}
              />
            </Col>
            <Col md={{span: 8}} lg={{span: 8}} xl={{span: 8}} xs={{span: 8}}>
              <Typography.Title level={5}>{t("Thông tin bài giảng", "Thông tin bài giảng")}</Typography.Title>
              <div>
                <Form.Item name="sectionName" label={t("Tên chương", "Tên chương")} rules={[validations.sectionName]}>
                  <FormItemDropdown placeholder={t("Chọn chương", "Chọn chương")}
                                    options={sectionList}/>
                </Form.Item>

                <Form.Item name="sequenceName" label={t("Tên bài giảng", "Tên bài giảng")} rules={[validations.sequenceName]}>
                  <FormInput placeholder={t("Nhập tên bài giảng", "Nhập tên bài giảng")}/>
                </Form.Item>

                <Form.Item label={t("Mô tả", "Mô tả")} name="description">
                  <FormInput placeholder={t("Nhập mô tả", "Nhập mô tả")}/>
                </Form.Item>

                <Typography.Title level={5} className='mt-3'>{t("Trạng thái", "Trạng thái")}</Typography.Title>
                <Form.Item>
                  <Radio checked>{t("Bản nháp", "Bản nháp")}</Radio>
                </Form.Item>
                <p>{t("Phần này sẽ không được người dùng nhìn thấy", "Phần này sẽ không được người dùng nhìn thấy")}</p>
              </div>

              <div className='mt-9'>
                <Space className='float-right'>
                  <Button onClick={handleClose} className="btn btn-outlined">
                    <Typography.Text>
                      {t("Hủy", "Hủy")}
                    </Typography.Text>
                  </Button>
                  <Button className="btn btn-primary" onClick={() => form.submit()}
                  >
                    <Typography.Text>
                      {t("Lưu", "Lưu")}
                    </Typography.Text>
                  </Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Form.Provider>
  )
}
